import React, { useState } from 'react'
import { Flex, Box } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'

import HorizontallyScrollablePanel from 'src/ui/HorizontallyScrollablePanel/HorizontallyScrollablePanel'
import SimpleTutorInfoCard, {
  SimpleTutorInfoType,
} from 'src/ui/TutorInfoCards/SimpleTutorInfoCard/SimpleTutorInfoCard'

export type Props = {
  tutors: SimpleTutorInfoType[]
  onChangeTutorRating: () => void
}

const TutorPanel: React.FC<Props> = ({ tutors, onChangeTutorRating }) => {
  const showTutorCountMobile = tutors?.length > 2
  const showTutorCountLargeScreens = tutors?.length > 5
  const customCompare = (a: SimpleTutorInfoType, b: SimpleTutorInfoType) => {
    return b.tutor.countOfJointLiveLessons - a.tutor.countOfJointLiveLessons
  }

  const sortTutors = (tutors: any) => {
    const sortedFavTutors = tutors
      ?.filter((t: any) => t.tutor.isFavorite)
      .sort(customCompare)

    const sortedRegularTutors = tutors
      ?.filter((t: any) => !t.tutor.isFavorite && !t.tutor.isBlocked)
      .sort(customCompare)

    return [...sortedFavTutors, ...sortedRegularTutors]
  }

  // After a user favs/unfavs tutor we change state here in order to reorder the tutor list without refetching the data
  //  on the gql side -- this way we immediately re-render and there is no 2-3 second delay after faving/unfaving.
  // On reload new data will be fetched.
  const [tutorsToShow, setTutorsToShow] = useState(sortTutors(tutors))

  const handleOrderChange = (login: string, newValue: boolean) => {
    const tempArray = tutorsToShow.map((item) => {
      return item.login === login
        ? { ...item, tutor: { ...item['tutor'], isFavorite: newValue } }
        : item
    })
    setTutorsToShow(sortTutors(tempArray))
  }

  return (
    <Box>
      <Flex
        flexDirection={{ _: 'column', tablet: 'row' }}
        justifyContent={{ _: 'stretch', tablet: 'space-between' }}
        mb="1x"
      >
        <Box as="p" variant="text.h5">
          {t('Your tutors')}
        </Box>
        <Box
          as="p"
          variant="text.subtitle"
          display={{
            mobile: showTutorCountMobile ? 'block' : 'none',
            tablet: showTutorCountLargeScreens ? 'block' : 'none',
          }}
        >
          {t('%{smart_count} Tutor |||| %{smart_count} Tutors', {
            smart_count: tutors?.length,
          })}
        </Box>
      </Flex>

      <HorizontallyScrollablePanel
        items={tutorsToShow}
        ItemComponent={SimpleTutorInfoCard}
        onClick={onChangeTutorRating}
        onOrderChange={handleOrderChange}
        customPanelStyle={{
          // to align the carousel with other grid elements in the Page Layout and fit the needed amount of tutor cards
          ml: '-10px',
          width: { _: 'auto', tabletWide: '736px', laptop: '944px' },
        }}
        customItemStyle={{
          width: { _: 168, laptop: 173 },
          height: '184px',
        }}
      />
    </Box>
  )
}

export default TutorPanel
